var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyBlueApporved(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5996_12171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.73346 7.7599L6.53346 10.0932L10.2668 5.42656M7.00013 14.2932C6.14216 14.2932 5.29259 14.1242 4.49993 13.7959C3.70727 13.4676 2.98704 12.9863 2.38037 12.3797C1.77369 11.773 1.29245 11.0528 0.964117 10.2601C0.635787 9.46743 0.466797 8.61787 0.466797 7.7599C0.466797 6.90193 0.635787 6.05236 0.964117 5.2597C1.29245 4.46704 1.77369 3.74681 2.38037 3.14013C2.98704 2.53346 3.70727 2.05221 4.49993 1.72388C5.29259 1.39555 6.14216 1.22656 7.00013 1.22656C8.73288 1.22656 10.3947 1.91489 11.6199 3.14013C12.8451 4.36537 13.5335 6.02715 13.5335 7.7599C13.5335 9.49264 12.8451 11.1544 11.6199 12.3797C10.3947 13.6049 8.73288 14.2932 7.00013 14.2932Z",
    stroke: "#273896"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5996_12171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.759766)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBlueApporved);
export default __webpack_public_path__ + "static/media/emptyBlueApporved.d1df52efe72d98153b5d3096487ec1e8.svg";
export { ForwardRef as ReactComponent };